import { CustomImage as Image } from '..';
import styles from './ExpertSection.module.css';

const ExpertsData = [
  [
    {
      img: 'web_v2/rare/features-v3/sleep.png',
      img_resp: 'web_v2/rare/features/sleep_resp.png',
      title: 'SLEEP INDEX',
      description:
        'Get a deeper understanding of your sleep quality and quantity through metrics such as sleep duration, RHR, restfulness, sleep stages such as REM, Deep and Light sleep.',
    },
    {
      img: 'web_v2/rare/features-v3/recovery.png',
      img_resp: 'web_v2/rare/features/recovery_resp.png',
      title: 'DYNAMIC RECOVERY',
      description:
        "A phenomenal new way to understand your body's readiness to take on activity load and stress, Dynamic Recovery understands when your body needs to recover. Not just that, it also provides recommendations that help you improve and adapts your score when you action these recommendations.",
    },
  ],
  [
    {
      img: 'web_v2/rare/features-v3/movement.png',
      img_resp: 'web_v2/rare/features/movement_resp.png',
      title: 'MOVEMENT INDEX',
      description:
        'The Movement Index is designed to keep you moving for optimum glucose metabolism and to increase your non-exercise energy usage. Track steps, workout, and calories for insights into your all-day movement.',
    },
    {
      img: 'web_v2/rare/features-v3/stress.png',
      img_resp: 'web_v2/rare/features/stress_Resp.png',
      title: 'STRESS RHYTHM SCORE',
      description:
        "A novel capability that helps you decode stress, this score considers the variations in your Heart Rate (HR), Heart Rate Variability (HRV), and Resting Heart Rate (RHR) against the backdrop of your circadian rhythm. It tells you if you're 'stimulated', 'relaxed', or 'stressed'.",
    },
  ],
  [
    {
      img: 'web_v2/rare/features-v3/womens.png',
      img_resp: 'web_v2/rare/features/women_resp.png',
      title: "WOMEN'S HEALTH",
      description:
        'Personalized multi-biomarker-based health insights for every stage of the unique journey of womanhood, helping you be more in tune with your body, and take charge of your reproductive health.',
    },
    {
      img: 'web_v2/rare/features-v3/caffine.png',
      img_resp: 'web_v2/rare/features/caffeine_resp.png',
      title: 'CAFFEINE WINDOW',
      description:
        'Optimise your stimulant consumption for enhanced productivity and sleep management.',
    },
  ],
];

export const ExpertSection = ({
  htmlId,
  isPricingPage,
}: {
  htmlId?: string;
  isPricingPage?: boolean;
}) => {
  return (
    <section className={styles.root} id={htmlId}>
        <div className="expert-content">
          {isPricingPage ? (
            <h2 className="head-pricing">Cutting edge technology.</h2>
          ) : (
            <h2 className="head">
              Expert Craftsmanship.
              <br /> Cutting Edge Technology.
            </h2>
          )}
          {ExpertsData.map((row, index) => {
            return (
              <div className="row" key={index}>
                {row.map((expert, index) => {
                  return (
                    <div className="card" key={expert.title + index}>
                      {/* Both variants rendered; CSS media query picks one so SSR paints correctly */}
                      <div className="img-container">
                        <Image
                          className="img-desktop"
                          width="1153"
                          height="909"
                          src={expert.img}
                          alt={expert.img}
                        />
                        <Image
                          className="img-mobile"
                          width="355"
                          height="462"
                          src={expert.img_resp}
                          alt={expert.img}
                        />
                      </div>
                      <div className="content">
                        <h4 className="title">{expert.title}</h4>
                        <p className="description">{expert.description}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </section>
    );
};
